import { render, staticRenderFns } from "./BuildPooledSops.vue?vue&type=template&id=5e48e40f&scoped=true"
import script from "./BuildPooledSops.vue?vue&type=script&lang=js"
export * from "./BuildPooledSops.vue?vue&type=script&lang=js"
import style0 from "./BuildPooledSops.vue?vue&type=style&index=0&id=5e48e40f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e48e40f",
  null
  
)

export default component.exports